/**
 * Single source of truth for environment variables.
 *
 * This is the only module allowed to touch `import.meta.env` directly.
 * Everything else imports typed values from here so env access is
 * centralized, greppable, and easy to mock in tests.
 */
export const env = {
    backendApiUri: import.meta.env.VITE_BACKEND_API_URI,
    firebaseApiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    firebaseAuthDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    firebaseAuthEmulatorUrl: import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_URL,
    buildEnvironment: import.meta.env.VITE_BUILD_ENVIRONMENT,
    isViteDev: import.meta.env.DEV,
    mode: import.meta.env.MODE,
} as const;
